<template>
  <div class="jms">
    <fieldset :disabled="loading" class="jms-fieldset">
      <mobile-sign
        ref="mobileSign"
        :items="mobileItems"
        @onloading="imzalayiciOnLoading"
        @completed="completed"
      ></mobile-sign>
      <div class="jms-message" v-if="processingMessage">{{ processingMessage }}</div>
      <div class="jms-bar">
        <div class="jms-bar-inner" role="group">
          <button
            type="button"
            class="jms-btn jms-btn-outline"
            @click="$emit('cancel')"
          >
            Vazgeç
          </button>
          <button type="button" class="jms-btn jms-btn-success" style="touch-action: manipulation;" :disabled="!signButtonEnabled || loading || isSigning" @click="sign">
            İmzala
          </button>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
import MobileSign from "./MobileSign.vue";
import axios from "axios";

export default {
  components: {
    MobileSign
  },
  data() {
    return {
      description: "",
      loading: false,
      processingMessage: null,
      signButtonEnabled: true,
      isSigning: false   // <-- yeni
    };
  },
  props: {
    isRem : {
      type: Boolean,
      default: false,
    },
    remSigningItems:{
      type: Array,
      required: false
    },
    remFinalizer:{
      type: Object,
      required: false
    },
    data: {
      type: Object,
      required: true
    }
  },
  mounted() {
    // this.$refs.description.focus();
  },
  created(){
    if(!this.isRem)
      this.checkSigner()
  },
  methods: {
    async checkSigner(){
      await axios.get(`/Job/CheckSigner/${this.data.Id}`).then(() => {  
        this.signButtonEnabled = true;  
      }).catch(() => {
          this.signButtonEnabled = false;  
          this.$izonayAlert(this.data.TrackingNo.Serial + ' - ' + this.data.TrackingNo.Number + ' numaralı işin içerisindeki dokümanları daha önce imzaladığınız için yeniden imza atamazsınız.');
      }) 
    },
    remSigningCompleted(){
        // Dosyaların imzalanması tamamlandığında sunucu tarafında kabul işlemini başlatır.
        this.loading = true;

        this.processingMessage = 'KEP Gönderiliyor...' ;
        this.$forceUpdate();

        axios.get(`/rem/sendrem/?jobId=${this.data.Id}&finalizerId=${this.remFinalizer.Id}`).then(x => {
            if(x.data.Success) {
                this.$router.push({ name: "Job", hash: "#Rem" });
                this.$izonayAlert(`İmzalama işlemi başarıyla tamamlandı.<br/><code>${ this.$options.filters.trackingNo(this.data.TrackingNo) }</code>`, "success");
            } else {
                this.$izonayAlert(x.data.ErrorMessages);
                this.loading = false;
            }
        }).catch(x => {
            console.warn('KEP gönderim işlemi başarısız: ', x);
            this.$izonayAlert("KEP gönderim işlemi başarısız.");
        }).then(() => {
          this.loading = false;
          this.processingMessage = null;
        }); 
    },
    sign() {
      // Senkron kilit — Vue reaktivitesini beklemez
      if (this._signLock) return;
      this._signLock = true;

      // Reaktif kilit — buton görsel olarak disable olsun
      this.isSigning = true;
      this.$refs.mobileSign.sign();
    },
    completed() {
      if (this._completedLock) return;
      this._completedLock = true;
      this.loading = true;
      this.processingMessage = "İmzalanan dosyalar işleniyor. Lütfen bekleyiniz...";
      this.$forceUpdate();

      var descriptionQuery = this.description ? `?description=${this.description}` : "";
      if(this.isRem){
        this.remSigningCompleted()
      }else {
        axios.get(`/job/acceptSignedFiles/${this.data.Id}${descriptionQuery}`)
        .then(x => {
          if (x.data.Success) {
            this.$router.push({ name: "Job", hash: "#MyWaiting" });
            this.$izonayAlert(`İmzalama işlemi başarıyla tamamlandı.<br/><code>${ this.$options.filters.trackingNo(this.data.TrackingNo) }</code>`, "success");
          } else {
            this.$izonayAlert(x.data.ErrorMessages);
            this.$refs.imzalayici.loading = false;
            this.loading = false;
          }
        })
        .catch(x => {
           if (this.isDuplicateBlocked(x)) return;  
          console.warn("Dosya kabul işlemi başarısız: ", x);
          this.$izonayAlert("İmzalanan dosya işleme alınamadı.");
          this._signLock = false;
          this._completedLock = false;
          this.isSigning = false;
        })
        .then(() => {
          this.loading = false;
          this.processingMessage = null;
        });
      }
      this.$emit("completed");
    },
    imzalayiciOnLoading(loading){
      this.loading = loading;
    }
  },
  computed: {
    mobileItems() {
      if(this.isRem){
        return this.remSigningItems;
      } else{
        return this.data.Documents.map(x => ({
          DocumentId: x.Id,
          SignatureFormat: x.SignatureFormat,
          FileName: x.UnsignedFile.FileName,
          Size: x.UnsignedFile.Size,
          State: "",
          FingerprintUrl: `/MobileSign/CalculateFingerprint/${this.data.Id}?documentId=${x.Id}`,
          PostUrl: `/MobileSign/Sign/${this.data.Id}?documentId=${x.Id}&fingerPrintTempFileId={0}`,
          PostParams: { JobId: this.data.Id, DocumentId: x.Id }
        }));
      }
      
    }
  }
};
</script>
<style scoped>
/* Voya: mobil imzalama */
.jms {
  padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 96px);
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
  color: #092154;
}

.jms-fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.jms-message {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #E5F1FF;
  font-weight: 500;
  font-size: 13px;
  line-height: 150%;
  color: #097DFF;
}

.jms-bar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  box-sizing: border-box;
  padding: 12px 16px calc(env(safe-area-inset-bottom, 0px) + 12px) 16px;
  border-top: 1px solid #EFEFEF;
  background-color: #ffffff;
  box-shadow: 0 -4px 16px rgba(9, 33, 84, 0.08);
}

.jms-bar-inner {
  display: flex;
  gap: 8px;
  max-width: 560px;
  margin: 0 auto;
}

.jms-btn {
  flex: 1 1 0;
  height: 48px;
  padding: 0 16px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-family: inherit;
  font-weight: 600;
  font-size: 15px;
  white-space: nowrap;
}

.jms-btn:disabled {
  opacity: 0.6;
}

.jms-btn-outline {
  border-color: #182F5E;
  background-color: #ffffff;
  color: #182F5E;
}

.jms-btn-outline:active {
  background-color: #F4F6FA;
}

.jms-btn-success {
  background-color: #1E9E57;
  color: #ffffff;
}

.jms-btn-success:active {
  background-color: #188547;
}
</style>
